"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORBIDDEN_ADD_RENAME_REMOVE_REL8N_NAMES = exports.ROOT_ADDR = exports.GIB_DELIMITER = exports.IBGIB_DELIMITER = exports.ROOT = exports.GIB = exports.IB = void 0;
exports.IB = 'ib';
exports.GIB = 'gib';
exports.ROOT = { ib: exports.IB, gib: exports.GIB, };
exports.IBGIB_DELIMITER = '^';
/**
 * Gib is often just a single hash for a single ib^gib record.
 * But if the ibgib has a tjp, which implies a timeline ("stream"
 * in some senses), then we will include the tjp gib hash alongside the
 * individual punctilear ibgib frame.
 *
 * ATOW this has the default schema of
 *
 * @example "comment abc^TJPHASH123", "comment abc^TJPHASH123.THISRECORDHASH456"
 */
exports.GIB_DELIMITER = '.';
exports.ROOT_ADDR = 'ib^gib'; // `${IB}${IBGIB_DELIMITER}${GIB}`;
/**
 * Some rel8ns should not be able to be renamed or removed.
 */
exports.FORBIDDEN_ADD_RENAME_REMOVE_REL8N_NAMES = ['past', 'ancestor', 'dna', 'tjp'];
